import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { of } from "rxjs/internal/observable/of";
import { UserService } from "../services/user.service";

@Injectable({
  providedIn: "root",
})
export class BaseService<T> {
  // Http options
  option = {};

  constructor(private _http: HttpClient, private _userService: UserService) {}

  /**
   * Http Post
   * @param endPoint
   * endpoint to make the request
   * @param body
   * Request body
   * @param options
   * Request options exmple: { observe: 'response'} to get full response
   */
  public post(endPoint: string, body: T, options?: any): Observable<any> {
    // Loading http options
    this.getOptions(options).subscribe((opt) => {
      this.option = opt;
    });

    // Http Request
    return this._http.post(endPoint, body, this.option);
  }

  /**
   * Http Post
   * @param endPoint
   * endpoint to make the request
   * @param body
   * Request body
   * @param options
   * Request options exmple: { observe: 'response'} to get full response
   */
  public patch(endPoint: string, body: T, options?: any): Observable<any> {
    // Loading http options
    this.getOptions(options).subscribe((opt) => {
      this.option = opt;
    });

    // Http Request
    return this._http.patch(endPoint, body, this.option);
  }

  /**
   * Http Put
   * @param endPoint
   * endpoint to make the request
   * @param body
   * Request body
   * @param options
   * Request options
   */
  public put(endPoint: string, body: T, options?: any): Observable<any> {
    // Loading http options
    this.getOptions().subscribe((opt) => {
      this.option = opt;
    });

    // Http Request
    return this._http.put(endPoint, body, this.option);
  }

  /**
   * Http Delete
   * @param endPoint
   * endpoint to make the request
   * @param options
   * Request options
   */
  public delete(endPoint: string, options?: any): Observable<any> {
    // Loading http options
    this.getOptions().subscribe((opt) => {
      this.option = opt;
    });

    // Http Request
    return this._http.delete(endPoint, this.option);
  }

  /**
   * Http Get
   * @param endPoint
   * endpoint to make the request
   * @param options
   * Request options
   */
  public get<Type>(
    endPoint: string,
    sort?: any,
    search?: any,
    options?: any
  ): Observable<Type> {
    // Loading http options
    this.getOptions(options).subscribe((opt) => {
      this.option = opt;
    });
    let finalEndPoint = endPoint + "?";
    if (sort != "" && sort != undefined) {
      finalEndPoint = `${finalEndPoint}&sort=${sort}`;
    }
    if (search != "" && search != undefined) {
      finalEndPoint = finalEndPoint + search;
    }

    // Http Request
    return this._http.get<Type>(finalEndPoint, this.option);
  }

  /**
   * Http Get
   * @param endPoint
   * endpoint to make the request
   * @param options
   * Request options
   */
  public getIp<Type>(endPoint: string): Observable<Type> {
    // Loading http options

    let finalEndPoint = endPoint;

    // Http Request
    return this._http.get<Type>(finalEndPoint);
  }

  /**
   * Http Get
   * @param endPoint
   * endpoint to make the request
   * @param options
   * Request options
   */
  public getNotHeaders<Type>(endPoint: string): Observable<Type> {
    return this._http.get<Type>(endPoint);
  }

  /**
   * Evaluate if the http options were supplied if not, set the global HttpOption
   * @param options
   * Request options
   */
  getOptions(options?: any): Observable<any> {
    let opt = {};

    let token: string = this._userService.getToken();

    // Si el token existe
    if (token != null) {
      let headers = new HttpHeaders({
        Authorization: "Bearer " + token,
      });
      if (options) {
        opt = options;
        if (options.headers && token != null)
          options.headers.set("Authorization", "Bearer " + token);
        else opt["headers"] = headers;
      } else {
        opt = { headers: headers };
      }
    }

    return of(opt);
  }

  Timeout(refresher?: any) {
    let timeout: any = 20;

    setTimeout(function () {
      if (refresher) {
        refresher.target.complete();
      }
    }, timeout);
  }

  public cancellRefresher(refresher?: any) {
    if (refresher) refresher.target.complete();
  }

  // Cancela el mensaje de 'cargando o el refresher'
  async cancelLoading(refresher?: any) {
    if (refresher) refresher.target.complete();
  }
}
